
//------common-options------------
const optionsValue = (id, value, key) => {
    if (!id || !value || !value.trim()) {
        return null;
    }
    return (
        <option key={key || id} value={id}>
            {value}
        </option>
    );
};


//---------contact-us---------------------------
const subjectValue = [
    {
        id: "Unable to upload profile picture",
        value: "Unable to upload profile picture",
    },
    {
        id: "Bill related Issue",
        value: "Bill related Issue",
    },
    {
        id: "Reports related Issue",
        value: "Reports related Issue",
    },
    {
        id: "sssssssssssssss",
        value: "  ",
    }
]

//---------report---------------------------
// today, yesterday, last_7_days, last_30_days, last_60_days, this_year, last_year, custom
const customDay = [
    {
        id: "today",
        value: "Today",
    },
    {
        id: "yesterday",
        value: "Yesterday",
    },
    {
        id: "last_7_days",
        value: "7 Days",
    },
    {
        id: "last_30_days",
        value: "30 Days",
    },
    {
        id: "last_60_days",
        value: "60 Days",
    }, {
        id: "this_year",
        value: "This Year",
    }, {
        id: "last_year",
        value: "Last Year",
    },
]
export const barIds = [
    "last_7_days",
    "last_30_days",
    "last_60_days",
    "this_year",
    "last_year",
];

const monthsArray = [
    { id: '1', name: 'January' },
    { id: '2', name: 'February' },
    { id: '3', name: 'March' },
    { id: '4', name: 'April' },
    { id: '5', name: 'May' },
    { id: '6', name: 'June' },
    { id: '7', name: 'July' },
    { id: '8', name: 'August' },
    { id: '9', name: 'September' },
    { id: '10', name: 'October' },
    { id: '11', name: 'November' },
    { id: '12', name: 'December' }
];

export { subjectValue, optionsValue, customDay, monthsArray }